import { useBrokerDetailsStore, FormField } from '../state/brokerDetailsStore';
import { useBrokerFieldFieldChanged } from '../hooks/useBrokerFieldChanged';
import { DateTimeBox } from '@apply/components';
import { ShowIf } from '@apply/ui';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const DateOfBirthField = () => {
    const value = useBrokerDetailsStore((s) => s.dateOfBirth);
    const updateFields = useBrokerDetailsStore((s) => s.updateFields);
    const isBroker = useBrokerDetailsStore((s) => s.isBroker);
    const changed = useBrokerFieldFieldChanged(FormField.DateOfBirth);

    return (
        <>
            <DateTimeBox
                id='hDateOfBirth'
                value={value}
                onChange={(v) => updateFields({ dateOfBirth: v ? new Date(v) : undefined })}
                label='Date of Birth'
                width={'100%'}
                required={isBroker}
            />
            <ShowIf showIf={changed}>
                <FontAwesomeIcon
                    icon='asterisk'
                    className='required-icon'
                />
            </ShowIf>
        </>
    );
};
